/**
 * @param {String} pageName - Pipe delimited String containing 1 to 4 items representing
 * the hierarchy and name of the page within the given application.
 */
 
export const dispatchPageLoad = pageName => {
    try {
        // instantiate a CustomEvent with an eventType of “pageLoad”
        const event = new CustomEvent('pageLoad', {
            detail: {
                page: pageName
            }
        });

        window.dispatchEvent(event);
    } catch (e) {
        // don't let analytics exception bubble up to cause problems elsewhere
        console.log(e);
    }
};

/**
 * Function for instantiating and dispatching a JavaScript CustomEvent for
 * signaling that an overlay has loaded within a given page.
 *
 * @param {String} overlay - String representing the name of the overlay
 * being loaded within the given page.
 */
export const dispatchOverlayLoad = overlay => {
    try {
        // instantiate a CustomEvent with an eventType of “overlayLoad”
        const event = new CustomEvent('overlayLoad', {
            detail: {
                // set the value of the function’s overlay parameter to
                // an “overlay” property on the CustomEvent’s detail object
                overlay
            }
        });
        // dispatch the CustomEvent from the body
        document.body.dispatchEvent(event);
    } catch (e) {
        // don't let analytics exception bubble up to cause problems elsewhere
        console.log(e);
    }
};


/**
 * Function for setting an exposed DOM object metricsData to
 * update analytics tracking the status of the respective user
 *
 * @param {String} status - String representing the name of the abbreviated
 * user status name
 */
export const setMetricsDataStatus = (isRasActive, clientType, rasEngagementStatus, proposalType, status, engagementTypeCreation) => {
    window.metricsData = {
        ...window.metricsData,
        ras: {
            isActive: isRasActive,
            engagementType: rasEngagementStatus,
            clientType,
            proposalType,
            engagementTypeCreation 
        },
        planningService: {
            engagementType: rasEngagementStatus,
            status
        },
    }
};

/**
* Function for instantiating and dispatching a JavaScript CustomEvent for
* signaling that an Action has Completed.
*
* @param {String} action - Pipe delimited String representing the type and name
* of the Action being of the Completed.
*/
export const dispatchActionComplete = action => {
    try {
        // instantiate a CustomEvent with an eventType of “overlayLoad”
        var event = new CustomEvent('actionComplete', {
            detail: {
                // set the value of the function’s action parameter to
                // an “action” property on the CustomEvent’s detail object
                action: action
            }
        });
        // dispatch the CustomEvent from the body
        document.body.dispatchEvent(event);
    } catch (e) {
        // don't let analytics exception bubble up to cause problems elsewhere
        console.log(e);
    }
};
